import { createElement, ReactNode } from 'react';
import MantineDescribedBy from './MantineDescribedBy';

/**
 * `inputContainer` для TextInput/Textarea/NumberInput/PasswordInput/YearPickerInput: id группы — в описание поля.
 * Обёртка есть всегда, даже без id: появление ошибки меняло бы дерево над `<input>`, и React пересоздал бы поле
 * вместе с фокусом.
 */
export const describedByContainer =
    (ids: string | undefined, outer?: (children: ReactNode) => ReactNode) =>
    (children: ReactNode): ReactNode => {
        const inner = createElement(MantineDescribedBy, { ids }, children);
        return outer ? outer(inner) : inner;
    };
